var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.01 0C4.49 0 0.00999832 4.48 0.00999832 10C0.00999832 15.52 4.49 20 10.01 20C15.53 20 20.01 15.52 20.01 10C20.01 4.48 15.53 0 10.01 0ZM10.01 15C9.46 15 9.01 14.55 9.01 14V10C9.01 9.45 9.46 9 10.01 9C10.56 9 11.01 9.45 11.01 10V14C11.01 14.55 10.56 15 10.01 15ZM9.01 7H11.01V5H9.01V7Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5b26d626b7431d28b143257e7c44e8d9.svg";
export { ForwardRef as ReactComponent };